// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../index';

import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const QuestionnaireCompleteExistingCustomerDocument = `
    mutation questionnaireCompleteExistingCustomer($input: QuestionnaireCompleteInput!) {
  questionnaireCompleteExistingCustomer(input: $input) {
    __typename
  }
}
    `;

export function useQuestionnaireCompleteExistingCustomerMutation() {
  return Urql.useMutation<SchemaTypes.QuestionnaireCompleteExistingCustomerMutation, SchemaTypes.QuestionnaireCompleteExistingCustomerMutationVariables>(QuestionnaireCompleteExistingCustomerDocument);
};